import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
  pubKey?: string;
  companyName?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '无锡市康复辅助器具社区租赁商户管理系统',
  pwa: true,
  logo: '/logo.jpg',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
  companyName: 'Jeremy Go',
  pubKey: `-----BEGIN RSA Public Key-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtlS3rV+/53P81qdmbZ2L
yZ7yNYxReZN7ZSz1kANOCQdT4ZKIkQJfcnQhNZDH0dZNvEEbRX6b+cXCIywd+XnF
hXn87I8Qr18pF6ydDhb2oc1nAgUf9XAoWxuP/+gvaTpUN+E9akzN8tBEsIRARE7Y
ZOEuqCTkvhV00AlHr5ZBNuLsyhmCcPqlV12hnsslQLbKorK1XnxnV9ZizX1blH99
lnXYHPviumVqY9jHDh5L59u8ffVV33s3hxyDE+URk0nAf77A+8VAFCMuHsX4PXln
fBNohCGfRmY9AFYvpmsQKoJL+ixJV3x5G82uOowPAnrER2DgqQ5u3A01lr6sIFE7
UQIDAQAB
-----END RSA Public Key-----`,
};

export default Settings;
